import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Tpl3plService } from '../../../services/tpl3pl.service';
import { GlobalSearchService } from '../../../services/globalsearchservice.service';

@Component({
	selector: 'app-tpl3pl-dashboard',
	templateUrl: './tpl3pl-dashboard.component.html',
	styleUrls: ['./tpl3pl-dashboard.component.scss']
})
export class Tpl3plDashboardComponent implements OnInit, OnDestroy {
	private static readonly ERROR_PREVIEW_MAX = 120;

	status: any = null;
	loading = false;
	private configSavedSub: Subscription | null = null;

	constructor(
		private tpl3plService: Tpl3plService,
		private globalSearchService: GlobalSearchService
	) {}

	ngOnInit(): void {
		this.loadStatus();
		this.configSavedSub = this.tpl3plService.configSaved$.subscribe(() => this.loadStatus());
	}

	ngOnDestroy(): void {
		this.configSavedSub?.unsubscribe();
	}

	previewFirstError(err: { message?: string } | null | undefined): string {
		const m = (err?.message ?? '').trim();
		const max = Tpl3plDashboardComponent.ERROR_PREVIEW_MAX;
		if (!m) {
			return '';
		}
		return m.length > max ? m.slice(0, max) + '…' : m;
	}

	loadStatus(): void {
		this.loading = true;
		this.tpl3plService.getStatus(true).subscribe({
			next: (result) => {
				this.status = result;
				this.loading = false;
			},
			error: (error) => {
				this.globalSearchService.showNotification('Error loading integration status', 'danger', 'bottom', 'right');
				this.loading = false;
			}
		});
	}
}
